export function AboutSection() {
  return (
    <section id="about" className="py-24 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
              <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">About Us</span>
            </div>
            <h2 className="text-5xl font-bold text-[#2C2C2C] mb-6">Your Trusted Las Vegas Remodeling Partner</h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              <strong>RW Construction Las Vegas LLC</strong> has been serving the Las Vegas community with exceptional residential and commercial remodeling services. Our commitment to quality craftsmanship and customer satisfaction has made us a trusted name in the construction industry.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              We believe in the philosophy of <strong>"One Call, Multiple Solutions"</strong> – providing comprehensive services that cover all your construction and remodeling needs. From pool repairs to complete property transformations, our experienced team delivers results that exceed expectations.
            </p>
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="text-4xl font-bold text-[#FF6B35] mb-2">20+</div>
                <div className="text-gray-600 text-sm">Years of Experience</div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="text-4xl font-bold text-[#FF6B35] mb-2">1900+</div>
                <div className="text-gray-600 text-sm">Projects Completed</div>
              </div>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-700">
              <i className="ri-checkbox-circle-fill text-[#FF6B35] text-xl"></i>
              Licensed &amp; Insured
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/cc639e2fa83bf3c64cadacbc6ee81336.jpg"
                alt="RW Construction Las Vegas team - professional turf and pavers installation"
                className="w-full h-full object-cover"
                title="RW Construction Turf and Pavers Installation"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#FF6B35] text-white rounded-2xl p-8 shadow-xl max-w-xs">
              <div className="text-3xl font-bold mb-2">100%</div>
              <div className="text-sm">Customer Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}